<template>
  <div v-frag>
    <v-card
      class="rounded-lg"
      color="secondaryApp"
      elevation="0"
      @click="$emit('press')"
      height="190"
      width="100%"
    >
      <!-- class="rounded-lg pt-6 pl-16 pl-sm-16 pl-md-14 pl-lg-12 pl-xl-14" -->
      <v-card
        class="rounded-lg pt-8"
        :color="color"
        elevation="2"
        height="125"
        width="100%"
        style="padding-left:32%"
      >
        <!-- <div style="padding:10%" class=""> -->
        <v-card :color="color" elevation="0" width="50" height="50">
          <v-img
            :aspect-ratio="1"
            class=""
            height="100%"
            width="100%"
            :src="icon"
            :background-color="color"
          ></v-img>
        </v-card>
      </v-card>
      <v-card-text class="text--primary text-center">
        {{ text }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "CardIeaCategory",
  props: ["text", "icon", "color"],
  data: () => ({}),
  methods: {}
};
</script>
